import { __values } from "tslib";
import { parse, Kind, getNamedType } from 'graphql';
export function parseSelectionSet(selectionSet) {
    var query = parse(selectionSet).definitions[0];
    return query.selectionSet;
}
export function typesContainSelectionSet(types, selectionSet) {
    var e_1, _a;
    var fieldMaps = types.map(function (type) { return type.getFields(); });
    var _loop_1 = function (selection) {
        if (selection.kind === Kind.FIELD) {
            var fields = fieldMaps.map(function (fieldMap) { return fieldMap[selection.name.value]; }).filter(function (field) { return field != null; });
            if (!fields.length) {
                return { value: false };
            }
            if (selection.selectionSet != null) {
                return { value: typesContainSelectionSet(fields.map(function (field) { return getNamedType(field.type); }), selection.selectionSet) };
            }
        }
        else if (selection.kind === Kind.INLINE_FRAGMENT && selection.typeCondition.name.value === types[0].name) {
            return { value: typesContainSelectionSet(types, selection.selectionSet) };
        }
    };
    try {
        for (var _b = __values(selectionSet.selections), _c = _b.next(); !_c.done; _c = _b.next()) {
            var selection = _c.value;
            var state_1 = _loop_1(selection);
            if (typeof state_1 === "object")
                return state_1.value;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
}
export function typeContainsSelectionSet(type, selectionSet) {
    var e_2, _a;
    var fields = type.getFields();
    try {
        for (var _b = __values(selectionSet.selections), _c = _b.next(); !_c.done; _c = _b.next()) {
            var selection = _c.value;
            if (selection.kind === Kind.FIELD) {
                var field = fields[selection.name.value];
                if (field == null) {
                    return false;
                }
                if (selection.selectionSet != null) {
                    return typeContainsSelectionSet(getNamedType(field.type), selection.selectionSet);
                }
            }
            else if (selection.kind === Kind.INLINE_FRAGMENT && selection.typeCondition.name.value === type.name) {
                return typeContainsSelectionSet(type, selection.selectionSet);
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return true;
}
//# sourceMappingURL=selectionSets.js.map